export default __webpack_public_path__ + "static/media/party.0ce19bb8.svg";